module.exports = __webpack_public_path__ + "static/insta3-7d339bd1cfa87b7665ab08484e2aa2fe.png";